import { Component } from '@angular/core';
import { BreadcrumbService } from '../../service/breadcrumb/breadcrumb.service';
import { MenuItem } from 'primeng/api';
import {Breadcrumb} from "primeng/breadcrumb";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  imports: [
    Breadcrumb
  ],
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {
  items: MenuItem[] = [];

  home: MenuItem = {
    icon: 'pi pi-home',
    label: 'Home',
    routerLink: '/',
    labelStyle: { color: 'var(--p-text-color)' },
    iconStyle: { color: 'var(--p-text-color)' }
  };

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbService.breadcrumbs$.subscribe(breadcrumbs => {
      this.items = breadcrumbs.map((item, index, arr) =>
        index === arr.length - 1
          ? { ...item, labelStyle: { color: 'var(--p-text-color)', fontWeight: '600' } }
          : { ...item, labelStyle: { color: 'var(--p-text-color)' } }
      );
    });
  }
}
